import { Checkbox } from "../ui/checkbox";
import { FormControl, FormField, FormItem } from "../ui/form";
import { Label } from "../ui/label";

export function FormCheckbox({
  control,
  name,
  label,
}: {
  control: any;
  name: string;
  label?: string;
}) {
  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem className="aero:flex aero:items-center aero:space-x-2">
          <FormControl>
            <Checkbox
              id={name}
              checked={field.value}
              onCheckedChange={field.onChange}
            />
          </FormControl>
          <Label
            htmlFor={name}
            className="aero:text-sm aero:font-medium aero:leading-none aero:peer-disabled:cursor-not-allowed aero:peer-disabled:opacity-70"
          >
            {label}
          </Label>
        </FormItem>
      )}
    />
  );
}
